export const findWarehouse = (typeId: string, warehouses: playground.Warehouse[]): playground.Warehouse | undefined => {
  for (const warehouse of warehouses) {
    if (warehouse.typeId === typeId) {
      return warehouse
      
    } else if (warehouse.children) {
      const childWarehouse = findWarehouse(typeId, warehouse.children)
      if (childWarehouse) {
        return childWarehouse
      }
    }
  }
}

export const checkHowManyIsAvailableForRent = (warehouses: playground.Warehouse[]) => {
  if (!warehouses || warehouses.length === 0) return 0
  let counter = 0
  for (const warehouse of warehouses) {
    if (warehouse.children && warehouse.children.length > 0) {
      counter += checkHowManyIsAvailableForRent(warehouse.children)

    } else if (warehouse.color_state === 'view_for_rent') {
      counter += 1
    }
  }
  return counter
}

/** Czy wybrany magazyn jest ostatnim wolnym w tym rozmiarze */
export const isLastAvailableForRent = (warehouse: playground.Warehouse | undefined, warehouses: playground.Warehouse[]) =>
  !!warehouse
  && warehouse.color_state === 'view_for_rent'
  && !!warehouse.warehouseData?.status?.isAvailableForRent
  && checkHowManyIsAvailableForRent(warehouses) === 1
